<textarea
  [spellcheck]="spellcheck"
  autocomplete="off"
  autocorrect="off"
  [readonly]="readonly"
  [formControl]="formControl"
></textarea>
